import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import YouTubeIcon from '@mui/icons-material/YouTube';
import { LoadingButton } from '@mui/lab';
import { Box, Button, CardContent, DialogTitle, ListItemIcon, Paper } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CommonHelper } from 'src/utils/commonHelper';

const FacebookPageAuthorizationModal = (props) => {
  const { t: translate } = useTranslation();
  const [isLoadingOn, setLoadingOn] = useState(false);
  const isCustomDomain = CommonHelper.CustomDomain();
  const isPortalAdmin = CommonHelper.GetBrandInfoFromLocalStorage("is_portal_admin");
  const handleConnectFacebook = () => {
    setLoadingOn(true);
    props.handleConnectFacebook();
  };

  const handleClose = () => {
    props.handleClose();
  };

  return (
    <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open>
      <DialogTitle id="customized-dialog-title" onClose={handleClose}>
        <Typography gutterBottom variant="h4">
          {props.reAuth
            ? `${translate('integration.facebook.reauthenticate_facebook_account')}`
            : `${translate('integration.facebook.have_facebook_page')}?`}
        </Typography>
        {(!isCustomDomain || isPortalAdmin) && (
          <Box display="flex" justifyContent="center" alignItems="center">
            <Button
              variant="outlined"
              startIcon={<YouTubeIcon />}
              onClick={() => window.open('https://www.youtube.com/watch?v=jFNtGNCITF0', '_blank')}
              color="primary"
            >
              {translate('common.tutorial')}
            </Button>
          </Box>
        )}
      </DialogTitle>
      <DialogContent dividers>
        <CardContent
          sx={{
            p: { xs: 0, md: 0 },
            color: 'grey.800',
          }}
        >
          <Typography variant="body1" sx={{ margin: 'auto 0', fontWeight: 'bold' }}>
            {translate('common.make_sure_completed_steps')}:
          </Typography>
          <Paper sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}>
            <ListItemIcon>
              <VerifiedUserIcon sx={{ color: 'success.dark', width: 18, height: 18, ml: 2, mt: 0.5 }} />
            </ListItemIcon>
            <Typography variant="body1">{translate('integration.facebook.admin_of_facebook_page')}</Typography>
          </Paper>
          <Paper sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}>
            <ListItemIcon>
              <VerifiedUserIcon sx={{ color: 'success.dark', width: 18, height: 18, ml: 2, mt: 0.5 }} />
            </ListItemIcon>
            <Typography variant="body1">
              {props.reAuth
                ? `${translate('integration.facebook.connecting_same_facebook')}`
                : `${translate('integration.facebook.create_facebook_page')}`}
            </Typography>
          </Paper>
        </CardContent>
      </DialogContent>
      <DialogActions>
        <Button color="error" variant="outlined" onClick={handleClose}>
          {translate('common.close')}
        </Button>
        <LoadingButton
          variant="contained"
          loading={isLoadingOn}
          autoFocus
          onClick={() => {
            handleConnectFacebook();
          }}
        >
          {props.reAuth ? `${translate('common.reconnect')}` : `${translate('common.connect')}`}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
export default FacebookPageAuthorizationModal;
